export const title = 'Marca tu tarjeta';
export const subTitle = 'Quien te atiende te debe mostrar un QR para escanear';
export const body = '';
